import axios from '../../localAxios';
import { WorkspaceMember } from '../getWorkspaceMembers';
import { workspaceRequestingUserRoleURL } from '../workspacesURLs';

/**
 * Simple api that returns the role of the current workspace user
 */
export async function getWorkspaceRole(workspaceId: string) {
  const url = workspaceRequestingUserRoleURL(workspaceId);
  const response = await axios.get<WorkspaceMember>(url.href);
  return response.data;
}
